export const converFromMoneyToNumber = (money) => parseInt(money.replace(/[$.\s]/g, ''));

export const maxAmountToBeExchanged = ({ maxAmountCC, totalPrice, rewardMoneyAvailable }) =>
  Math.min(maxAmountCC ?? maxAmountCC, totalPrice) > rewardMoneyAvailable
    ? rewardMoneyAvailable
    : Math.min(maxAmountCC ?? maxAmountCC, totalPrice);
